module.exports = __webpack_public_path__ + "img/bg_certificate.9793043b.jpg";